function ReferenceInfinitNutritionController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	
	
	/* PRIVATE VARIABLES */
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}
	
   
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			// init		
			var parallax1 = new Rellax('.product', {
				speed: 4.0,
				center: true,
				wrapper: null,
				round: true,
				vertical: true,
				horizontal: false
			});	

			Gridle.on('update', function (updatedStates, activeStates, inactiveStates) {
				parallax1.refresh();
			});		

			_this.inited = true;
		}
	};
		

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
